export type ISubscriptions = {
  email: boolean;
  phone: boolean;
  post: boolean;
};

export enum Intent {
  REMO = "remortgage",
  REMO_RESEARCH = "remortgage-research",
  PURCHASE_OFFER_MADE = "purchase-offer-made",
  PURCHASE_VIEWING = "purchase-viewing",
  PURCHASE_RESEARCH = "purchase-research"
}
